import { Badge, Button, Divider, styled } from "@mui/material";
import React from "react";
import CoreSpinner from "../../../app/core/components/CoreSpinner/CoreSpinner.jsx";
import { t } from "i18next";
import CustomUserIcon from "../../../app/assets/custom-icons/CustomUserIcon.jsx";
import { formattaDataOra } from "../../../utils/functions/date-utils.js";
import { useSelector } from "react-redux";
import { ROLE } from "../../../utils/constants/profiles.js";

const ListaChat = ({ chat, onOpen, loading, onSetread }) => {
  const colorPrimary = useSelector((state) => state.app.primaryColor);
  const colorSecondary = useSelector((state) => state.app.secondaryColor);
  const role = useSelector((state) => state.app.role);

  const StyledBadge = styled(Badge)(({ theme }) => ({
    "& .MuiBadge-badge": {
      border: `2px solid white`,
      padding: "5px",
    },
  }));

  if (loading) {
    return (
      <div
        style={{
          width: "450px",
          height: "720px",
          border: "1px solid lightgrey",
        }}
      >
        <CoreSpinner />
      </div>
    );
  }

  return (
    <div
      className="overflow-y-scroll overflow-x-hidden"
      style={{
        height: `${role === ROLE.USER ? "886px" : "850px"}`,
        border: "1px solid lightgrey",
      }}
    >
      {chat?.length === 0 && (
        <div className="w-full flex justify-center">
          <p className="text-gray">{t("NoChatPresent")}</p>
        </div>
      )}
      {chat
        ?.sort((a, b) => {
          if (a.status === "Open" && b.status !== "Open") return -1;
          if (a.status !== "Open" && b.status === "Open") return 1;
          return new Date(b.updatedAt) - new Date(a.updatedAt);
        })
        .map((el) => {
          return (
            <div className="w-full" key={el.id}>
              <Button
                className={`w-full
                  ${
                    el.status === "Open"
                      ? "rounded-none "
                      : " bg-zinc-100 rounded-none"
                  }`}
                onClick={
                  el.status === "Open" ? () => onSetread(el) : () => onOpen(el)
                }
              >
                <div className="flex w-full text-start items-center">
                  <div className="flex w-full text-black justify-between items-center ">
                    <div className="flex items-center space-x-4 w-full">
                      <div className="w-14 h-14 ml-2 relative ">
                        <CustomUserIcon className="w-full" />
                      </div>
                      {el.status === "Open" && (
                        <StyledBadge
                          badgeContent={el.unreadMessages}
                          invisible={el.unreadMessages > 0 ? false : true}
                          color="error"
                          className="absolute top-8 left-12 "
                        />
                      )}
                      <div>
                        <div>
                          <p className="m-0 font-bold ">{el.userName}</p>
                          <p
                            className="m-0 font-bold lowercase text-xs"
                            style={{ color: colorPrimary }}
                          >
                            {el.userEmail}
                          </p>
                        </div>
                        <div className="m-0">
                          <p
                            className="m-0 font-bold text-xs "
                            style={{ color: colorSecondary }}
                          >
                            {el.adminUserName}
                          </p>
                          <p className="m-0" style={{ fontSize: "9px" }}>
                            {formattaDataOra(el.updatedAt)}{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    {el.practiceId && (
                      <Divider orientation="vertical" flexItem />
                    )}

                    {el.practiceId && (
                      <div className="w-1/3 flex justify-end mx-2">
                        <div className="flex flex-col justify-center items-end">
                          {el.status === "Open" ? (
                            <small className="text-green-600 font-bold">
                              {el.status === "Open" && "Attiva"}
                            </small>
                          ) : (
                            <small className="text-red-600 font-bold">
                              {el.status === "Archived" && "Archiviata"}
                            </small>
                          )}
                          <small
                            className="font-bold text-right "
                            style={{ fontSize: "10px" }}
                          >
                            {el.name}
                          </small>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </Button>
              <Divider className="w-full " />
            </div>
          );
        })}
    </div>
  );
};

export default ListaChat;
